<div class="p-6">
  <app-nav-button [route]="'/admin/package'"></app-nav-button>
  <h1 class="text-2xl font-bold text-primary mb-2">
    Paquetes de la Compañía
  </h1>
  <p class="text-gray-600 mb-6">
    Listado de los paquetes activos asignados a esta compañía.
  </p>
  <app-loading *ngIf="isLoading"></app-loading>
  <div *ngIf="!isLoading">
    <app-table-generic [columns]="columns" [data]="packages" [page]="page" [pageSize]="pageSize" [total]="total"
      [actions]="['edit']" (edit)="openActivateModal($event)" (pageChange)="onPageChange($event)">
    </app-table-generic>
  </div>
</div>
<div *ngIf="showModal" class="fixed inset-0 bg-black/60 flex items-center justify-center z-50">
  <div class="bg-white rounded-lg shadow-lg max-w-sm w-full p-6 text-center">
    <h2 class="text-lg font-semibold text-gray-800 mb-4">
      ¿Estás seguro de activar este paquete?
    </h2>
    <div class="flex justify-center gap-4">
      <button (click)="closeModal()"
        class="px-4 py-2 rounded-md border border-gray-300 text-gray-700 hover:bg-gray-100 transition">
        Cancelar
      </button>
      <app-loading-button (click)="confirmActivate()" [text]="'Confirmar'" [loading]="isLoadingActivate" type="button">
      </app-loading-button>
    </div>
  </div>
</div>
